module.exports = __webpack_public_path__ + "static/media/paw.a63e48bd.png";